module.exports = __webpack_public_path__ + "media/images/mypage/mypage_t2-bc7b813d69569840e993a910ad1f0203.gif";